<template>
  <div v-if="unitsFilter" class="filter__box">
    <div v-if="$root.globalData" class="filter__box__title">
      <p>{{ $root.globalData.keys.filter_text }}</p>
      <span> <FilterIcon /> </span>
    </div>
    <template v-if="$root.globalData">
      <div class="filter__category">
        <v-select
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }"
          class="unitsFilter"
          v-model="selectedCategory"
          :items="unitsFilter.categories"
          :label="$root.globalData.keys.category_text"
          item-text="title"
          item-value="id"
          prepend-icon="mdi-barley"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selectedCategory.length - 1 }} )
            </span>
          </template>
        </v-select>
      </div>
      <div class="filter__category">
        <v-select
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }"
          class="unitsFilter"
          v-model="selectedTowns"
          :items="unitsFilter.towns"
          :label="$root.globalData.keys.industrytown_text"
          item-text="title"
          item-value="id"
          prepend-icon="mdi-barley"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selectedTowns.length - 1 }} )
            </span>
          </template>
        </v-select>
      </div>
      <div class="filter__category">
        <v-select
          :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }"
          class="unitsFilter"
          v-model="selectedProvinces"
          :items="unitsFilter.provinces"
          :label="$root.globalData.keys.province_text"
          item-text="name"
          item-value="id"
          prepend-icon="mdi-map-marker"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selectedProvinces.length - 1 }} )
            </span>
          </template>
        </v-select>
      </div>
      <div class="filter__category">
        <v-select
          class="unitsFilter"
          v-model="selectedCities"
          :items="cities"
          :label="$root.globalData.keys.city_text"
          item-text="name"
          item-value="id"
          prepend-icon="mdi-map"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selectedCities.length - 1 }} )
            </span>
          </template>
        </v-select>
      </div>
    </template>
    <!-- 
    <div class="active__factory">
      <p>فقط شرکت های فعال</p>

      <label class="switch">
        <input v-model="status" type="checkbox" />
        <span class="slider round"></span>
      </label>
    </div> -->

    <button @click="filterIndustry()" class="filter__btn">{{$root.globalData.keys.filter_text}}</button>
  </div>
</template>

<script>
import FilterIcon from "../svgs/FilterIcon.vue";
import CategoryFilterIcon from "../svgs/CategoryFilterIcon.vue";
import RegionIcon from "../svgs/RegionIcon.vue";
import MapIcon from "./MapIcon.vue";
import CityIcon from "../svgs/CityIcon.vue";
export default {
  data() {
    return {
      status: true,
      options: [],
      fakeList: [],
      selectedCategory: [],
      selectedTowns: [],
      selectedProvinces: [],
      selectedCities: [],
    };
  },

  mounted() {
    if (this.unitsFilter == null) {
      this.$axios.get("front/unitFilters").then((res) => {
        this.$store.commit("setUnitsFilter", res.data.filters);
        this.$store.commit("setprovinces", res.data.filters.provinces);
        this.$store.commit("setcities", res.data.filters.cities);
        this.$store.commit("setcountries", res.data.filters.countries);
        this.fakeList = res.data.filters;
      });
    }
    if (this.$route.query.categoryIds) {
      let list = [];
      this.$route.query.categoryIds.split(",").forEach((id) => {
        list.push(Number(id));
      });
      this.selectedCategory = list;
    }
    if (this.$route.query.provinceIds) {
      let list = [];

      this.$route.query.provinceIds.split(",").forEach((id) => {
        list.push(Number(id));
      });
      this.selectedProvinces = list;
    }
    if (this.$route.query.cityIds) {
      let list = [];

      this.$route.query.cityIds.split(",").forEach((id) => {
        list.push(Number(id));
      });
      this.selectedCities = list;
    }
    if (this.$route.query.townIds) {
      let list = [];

      this.$route.query.townIds.split(",").forEach((id) => {
        list.push(Number(id));
      });
      this.selectedTowns = list;
    }
  },
  methods: {
    filterIndustry() {
      let query = "?";
      query += `status=${this.status == true ? 1 : 0}`;
      if (this.selectedCategory.length > 0) {
        query += "&categoryIds=";
        this.selectedCategory.forEach((id, index) => {
          query += `${id}${
            index == this.selectedCategory.length - 1 ? "" : ","
          }`;
        });
      }

      if (this.selectedTowns.length > 0) {
        query += "&townIds=";
        this.selectedTowns.forEach((id, index) => {
          query += `${id}${index == this.selectedTowns.length - 1 ? "" : ","}`;
        });
      }

      if (this.selectedProvinces.length > 0) {
        query += "&provinceIds=";
        this.selectedProvinces.forEach((id, index) => {
          query += `${id}${
            index == this.selectedProvinces.length - 1 ? "" : ","
          }`;
        });
      }
      if (this.selectedCities.length > 0) {
        query += "&cityIds=";
        this.selectedCities.forEach((id, index) => {
          query += `${id}${index == this.selectedCities.length - 1 ? "" : ","}`;
        });
      }
      if (this.$route.query.page) {
        query += `&page=${this.$route.query.page}`;
      } else {
        query += `&page=1`;
      }
      // this.$router.replace({ name: "industry", query: { query } });
      this.$router.push(`/Industry${query}`);

      this.$emit("changeFilter");
    },
  },
  props: {
    filters: Object,
    selectedOption: Object,
  },
  components: {
    FilterIcon,
    CategoryFilterIcon,
    RegionIcon,
    MapIcon,
    CityIcon,
  },
  watch: {
    selectedProvinces(newVal) {
      if (newVal.length > 0) {
        this.cities = this.fakeList.cities.filter((item) => {
          if (newVal.find((element) => element == item.province_id)) {
            return item;
          }
        });
      } else {
        this.cities = this.fakeList.cities;
      }
    },
  },
  computed: {
    unitsFilter() {
      return this.$store.getters.getUnitsFilter;
    },
    cities: {
      get() {
        return this.$store.getters.getcities;
      },
      set(list) {
        this.$store.commit("setcities", list);
      },
    },
  },
};
</script>

<style scoped>
.filter__box {
  padding: 0 1rem;
}
.filter__box__title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-top: 1rem;
}

.filter__box__title p {
  font-weight: bold;
}

.filter__category {
  background-color: #fff;
  width: 100%;
  box-shadow: 0px 2px 10px #bbb;
  border-radius: 5px;
  cursor: pointer;
}
.filter__category__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  margin-top: 2rem;
}

.active__factory {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 7px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.filter__btn {
  width: 100%;
  background-color: #2196f3;
  color: #fff;
  margin: 2rem 0;
  padding: 10px 0;
  border-radius: 5px;
  cursor: pointer;
}
</style>
<style>
.unitsFilter .v-input__control .v-input__slot .v-select__slot .v-label {
  left: unset !important;
  right: 0 !important;
}
.unitsFilter .theme--light.v-icon {
  color: rgb(13 110 253) !important;
}
.unitsFilter .v-input__slot:before {
  border-color: transparent !important;
}
</style>
